var map = {
	"./03_get_deposit_hisrec.json": "ZlbJ",
	"./04_get_withdraw_history.json": "DNed",
	"./05_post_wallets_coins.json": "BYvq",
	"./06_post_wallets_withdraw.json": "yxdj",
	"./13.get_wallet_queryDepositAddress.json": "WnFl",
	"./14_get_risk_deposit_records.json": "JbVL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "loP8";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/api/wallet \.json$
// module id = loP8
// module chunks = 3